import { IUpdateMetaTagDTO } from '@/models/metaTags.model';
import { TMetaTagsFormValues } from '../helpers/types';
import CreateMetaTagsDTO from './CreateMetaTagDTO';

class UpdateMetaTagsDTO extends CreateMetaTagsDTO implements IUpdateMetaTagDTO {
  id: string;

  constructor({
    id,
    index,
    locale,
    slug,
  }: TMetaTagsFormValues & {
    id: string;
  }) {
    super({ slug, index, locale });
    this.id = id;
  }
}

export default UpdateMetaTagsDTO;
